<template>
  <section class="sub-navigation" :class="mainClasses">
    <nav class="sub-navigation__container">
      <base-nav-list
        :items="fields.firstLevel?.value"
        data-test-id="sub-nav-1-lvl"
        :handle-sub-navigation-click="handleSubNavigationClick"
      />
      <base-nav-list
        v-if="fields.secondLevel?.value?.length"
        :items="fields.secondLevel.value"
        second-level
        data-test-id="sub-nav-2-lvl"
        :handle-sub-navigation-click="handleSubNavigationClick"
      />
    </nav>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useButtonsAndLinksTracking } from '../../data-layer/hooks/useButtonsAndLinksTracking';
import BaseNavList from '../2_elements/BaseNavList/BaseNavList.vue';
import { useJssStore } from '../../stores/jssStore';
import {
  useDetectVariantByBrand,
  VAR_DARK,
  variantedComponents,
} from '../../utils/componentVariants';
import type { SubNavigationProps } from './types';

const props = withDefaults(defineProps<SubNavigationProps>(), {
  fields: () => ({}),
  params: () => ({}),
});

const { trackLinkState } = useButtonsAndLinksTracking({ componentName: 'sub_navigation' });

const jssStore = useJssStore();
const detectVariant = useDetectVariantByBrand();

const mainClasses = computed(() => {
  const variantClasses = detectVariant(variantedComponents.SUBNAVIGATION);
  return [
    variantClasses[VAR_DARK] && 'var-dark',
    jssStore.brandName === 'ChefBrewer' && 'bottom-white-border',
    jssStore.brandName === 'Belhaven' && 'blh-full-width',
    !props.fields.secondLevel?.value?.length && 'sub-navigation--one-lvl',
  ];
});

const handleSubNavigationClick = (item: { title?: string }) => {
  trackLinkState(item.title || '', 'navigation_interaction');
};
</script>

<style lang="scss">
@import './scss/SubNavigation.scss';
</style>
